import React from "react"
import KEYBlue from "../common/keylist-blue"
type Props = {
  title: string
}

const AppstoreOptimizeServices: React.FC<Props> = ({ title }) => {
  return (
    <section className="Development-Services section-py bg-grey">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12  justify-start items-center">
          <div className="lg:col-span-8">
            <div className="Development-Services-head text-start mb-5">
              <h2 className="fw-700 fs-xl">{title}</h2>
            </div>
          </div>
        </div>
        <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
              <p className="fs-md text-secondary mb-0 fw-400">
                As a renowned app store optimization company, Moweb provides highly customized ASO solutions to enhance your app’s visibility and conversions. Committed to provide world-class services, you can definitely witness an exponential increase in your organic app download rates that help you promote your app from scratch on the leading app stores. We try hard to get your app discovered.
              </p>
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
              <KEYBlue text="Click-Through-Rates" />
              <KEYBlue text="Download & Engagement Analysis" />
              <KEYBlue text="On-Page Optimization" />
              <KEYBlue text="Off-Page Optimization" />
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
              <KEYBlue text="Reviews & Ratings" />
              <KEYBlue text="Updating & Fixing Bugs" />
              <KEYBlue text="Keyword Research" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AppstoreOptimizeServices
